


export function LoaderPagination(props) {

    return (
        <div>
            <div
                style={{
                    padding:'0.3em',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                <div className="loader-clousure-movements"> </div>
                <span className="p-2">Cargando notificaciones...</span>
            </div>

        </div >
    )

}